import { Component } from "@angular/core";

@Component({
  selector: 'app-epayfail',
  templateUrl: './epayfail.component.html',
  styleUrls: ['./epayfail.component.scss'], 
})
export class EPayFailComponent {

}
